import React, { useState } from "react"
import { ActivityIndicator, TouchableOpacity, View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { RFValue } from "react-native-responsive-fontsize"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { Avatar } from "react-native-paper"
import FavorisInactif from "@Components/CustomIcon/FavorisInactif"
import FavorisActif from "@Components/CustomIcon/FavorisActif"
import { frenchDate, fullName } from "@Utils/utils"
import CustomBorderedText from "@Components/CustomBorderedText"
import { ForumService } from "@Services/Knowledge/SavoirEtre/Forum.Service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"

const TopicHeader = (props) => {
    const { headerData, forumId, setUpdateList } = props
    const [updating, setUpdating] = useState(false)
    const userName = fullName(headerData?.owner?.firstName, headerData?.owner?.lastName) ?? ""
    const postedAt = frenchDate(headerData?.createdAt) ?? ""
    const postSubject = headerData?.subject ?? ""
    const postContent = headerData?.content ?? ""

    const successfull = () => {
        setUpdating(false)
        setUpdateList((prev) => !prev)
        ShowToast({
            type: "success",
            message: "Opération réussie."
        })
    }

    const failed = () => {
        setUpdating(false)
        ShowToast({
            type: "error",
            message: "Une erreur est survenue."
        })
    }

    const handleFavorite = () => {
        setUpdating(true)
        if (Boolean(headerData?.isFavorite)) {
            ForumService.removeFavorite(forumId)
                .then(() => {
                    successfull()
                })
                .catch(() => {
                    failed()
                })
        } else {
            ForumService.setForumFavorite(forumId)
                .then(() => {
                    successfull()
                })
                .catch(() => {
                    failed()
                })
        }
    }

    const favoriteIcon = Boolean(headerData?.isFavorite) ? <FavorisActif /> : <FavorisInactif />

    const axisName = headerData?.axis?.name?.replace("Axe", "")

    const favoriteContent = updating ? (
        <ActivityIndicator color={baseColors.green.primary} size={25} />
    ) : (
        <TouchableOpacity onPress={handleFavorite}>{favoriteIcon}</TouchableOpacity>
    )

    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <View style={styles.leftContent}>
                    {/* <Avatar.Image source={{ uri: "" }} style={styles.avatar} size={50} /> */}
                    <Avatar.Text size={50} style={styles.avatar} label="AV" />
                    <View style={styles.userInfos}>
                        <OpenSansText
                            numberOfLines={2}
                            defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                            fontSize={RFValue(16)}
                        >
                            {userName ?? "---"}
                        </OpenSansText>
                        <OpenSansText
                            style={styles.createdDate}
                            defaultFontFamily={baseFontFamily.OpenSansRegular}
                            fontSize={RFValue(14)}
                        >
                            {postedAt ?? "---"}
                        </OpenSansText>
                    </View>
                </View>

                {favoriteContent}
            </View>

            <View style={styles.content}>
                <BreeSerifText style={styles.title} fontSize={RFValue(24)}>
                    {postSubject}
                </BreeSerifText>
                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={RFValue(16)}>
                    {postContent ?? ""}
                </OpenSansText>
            </View>

            <View style={styles.category}>
                <CustomBorderedText
                    color={baseColors.orange.primary}
                    backgroundColor={baseColors.white}
                    label={axisName}
                />
            </View>
        </View>
    )
}

export default TopicHeader
